(function () {
  'use strict';

  var statusCounter = 0;
  var lastEditTrigger = null;
  var editDialogWasOpen = false;
  var lastPurchaseLimitTrigger = null;
  var purchaseLimitDialogWasOpen = false;

  function cleanText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function optionName(input) {
    var fieldset = input.closest('fieldset');
    var legend = fieldset && fieldset.querySelector('legend');
    if (!legend) return cleanText(input.name);

    var clone = legend.cloneNode(true);
    clone.querySelectorAll('[data-header-option]').forEach(function (node) {
      node.remove();
    });
    return cleanText(clone.textContent).replace(/:$/, '');
  }

  function enhanceVariantRadio(input) {
    if (!input.hasAttribute('aria-label')) {
      var name = optionName(input);
      var value = cleanText(input.value);
      input.setAttribute('aria-label', name ? name + ': ' + value : value);
    }

    if (!input.closest('.product-edit-options') || input.dataset.batchBEditRadioReady === 'true') return;

    input.addEventListener('keydown', function (event) {
      var keys = ['ArrowLeft', 'ArrowUp', 'ArrowRight', 'ArrowDown', 'Home', 'End'];
      if (keys.indexOf(event.key) === -1) return;

      var fieldset = input.closest('fieldset');
      if (!fieldset) return;
      var radios = Array.from(fieldset.querySelectorAll('.product-form__radio:not([disabled])'));
      if (!radios.length) return;

      var currentIndex = radios.indexOf(input);
      var nextIndex = currentIndex;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = radios.length - 1;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (currentIndex - 1 + radios.length) % radios.length;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (currentIndex + 1) % radios.length;

      event.preventDefault();
      radios[nextIndex].focus({ preventScroll: true });
      radios[nextIndex].click();
      syncEditRadioGroup(fieldset);
    });

    input.dataset.batchBEditRadioReady = 'true';
  }

  function syncEditRadioGroup(fieldset) {
    var radios = Array.from(fieldset.querySelectorAll('.product-form__radio:not([disabled])'));
    if (!radios.length) return;
    var current = radios.find(function (radio) { return radio.checked; }) || radios[0];
    radios.forEach(function (radio) {
      enhanceVariantRadio(radio);
      radio.setAttribute('tabindex', radio === current ? '0' : '-1');
    });
  }

  function enhanceEditDialog(dialog) {
    if (!dialog) return;
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    dialog.setAttribute('aria-labelledby', 'halo-edit-cart-title');
    dialog.querySelectorAll('.product-edit-options fieldset').forEach(syncEditRadioGroup);
    dialog.querySelectorAll('.product-edit-quantity .btn-quantity[role="button"]').forEach(function (button) {
      if (button.dataset.batchBQuantityReady === 'true') return;
      button.addEventListener('keydown', function (event) {
        if (event.key !== ' ') return;
        event.preventDefault();
        button.click();
      });
      button.dataset.batchBQuantityReady = 'true';
    });
  }

  function dialogFocusables(dialog) {
    return Array.from(dialog.querySelectorAll('button:not([disabled]), a[href], input:not([type="hidden"]):not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(function (element) {
      var style = window.getComputedStyle(element);
      return style.display !== 'none' && style.visibility !== 'hidden' && element.getClientRects().length > 0;
    });
  }

  function purchaseLimitDialog() {
    var messages = document.querySelector('#purchase_limit_messages');
    return messages && messages.closest('#myModal');
  }

  function purchaseLimitDialogIsOpen(dialog) {
    if (!dialog) return false;
    var style = window.getComputedStyle(dialog);
    return dialog.getAttribute('aria-hidden') !== 'true' &&
      style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      dialog.getClientRects().length > 0;
  }

  function enhancePurchaseLimitDialog(dialog) {
    if (!dialog) return;

    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    dialog.setAttribute('aria-label', 'Purchase limit notice');
    dialog.setAttribute('tabindex', '-1');

    var messages = dialog.querySelector('#purchase_limit_messages');
    if (messages) {
      messages.setAttribute('role', 'alert');
      messages.setAttribute('aria-live', 'assertive');
      messages.setAttribute('aria-atomic', 'true');
    }

    var loader = dialog.querySelector('#mc-loader') || document.querySelector('#mc-loader');
    if (loader) {
      loader.setAttribute('role', 'status');
      loader.setAttribute('aria-live', 'polite');
      loader.setAttribute('aria-label', 'Checking purchase limits');
    }

    var closeButton = dialog.querySelector('.close-custom');
    if (closeButton && closeButton.dataset.batchBKorCloseReady !== 'true') {
      closeButton.setAttribute('role', 'button');
      closeButton.setAttribute('tabindex', '0');
      closeButton.setAttribute('aria-label', 'Close purchase limit notice');
      closeButton.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        closeButton.click();
      });
      closeButton.dataset.batchBKorCloseReady = 'true';
    }
  }

  function syncPurchaseLimitDialogState() {
    var dialog = purchaseLimitDialog();
    if (!dialog) return;

    enhancePurchaseLimitDialog(dialog);
    var isOpen = purchaseLimitDialogIsOpen(dialog);
    var nextAriaHidden = isOpen ? 'false' : 'true';
    if (dialog.getAttribute('aria-hidden') !== nextAriaHidden) {
      dialog.setAttribute('aria-hidden', nextAriaHidden);
    }

    if (isOpen && !purchaseLimitDialogWasOpen) {
      purchaseLimitDialogWasOpen = true;
      window.setTimeout(function () {
        if (!purchaseLimitDialogIsOpen(dialog) || dialog.contains(document.activeElement)) return;
        var first = dialogFocusables(dialog)[0];
        (first || dialog).focus({ preventScroll: true });
      }, 50);
    }

    if (!isOpen && purchaseLimitDialogWasOpen) {
      purchaseLimitDialogWasOpen = false;
      if (lastPurchaseLimitTrigger && document.contains(lastPurchaseLimitTrigger)) {
        lastPurchaseLimitTrigger.focus({ preventScroll: true });
      }
    }
  }

  function syncEditDialogState() {
    var dialog = document.querySelector('[data-edit-cart-popup]');
    if (!dialog) return;

    var isOpen = document.body.classList.contains('edit-cart-show');
    dialog.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    enhanceEditDialog(dialog);

    if (isOpen && !editDialogWasOpen) {
      editDialogWasOpen = true;
      window.setTimeout(function () {
        var closeButton = dialog.querySelector('[data-close-edit-cart]');
        if (closeButton && document.body.classList.contains('edit-cart-show') && !dialog.contains(document.activeElement)) {
          closeButton.focus({ preventScroll: true });
        }
      }, 150);
    }

    if (!isOpen && editDialogWasOpen) {
      editDialogWasOpen = false;
      if (lastEditTrigger && document.contains(lastEditTrigger)) {
        lastEditTrigger.focus({ preventScroll: true });
      }
    }
  }

  function versionCardLabel(card) {
    var tooltip = card.querySelector('.tooltip');
    var image = card.querySelector('img[alt]');
    return cleanText(
      card.getAttribute('aria-label') ||
      (tooltip && tooltip.textContent) ||
      (image && image.getAttribute('alt'))
    );
  }

  function enhanceVersionCard(card) {
    if (card.dataset.batchBKeyboardReady === 'true') return;

    var destination = cleanText(card.getAttribute('data-url'));
    var hasInlineClick = card.hasAttribute('onclick');
    var isCurrent = card.classList.contains('default') || card.classList.contains('selected');
    var label = versionCardLabel(card);

    if (label) card.setAttribute('aria-label', label);

    if (destination || hasInlineClick || !isCurrent) {
      card.setAttribute('role', 'link');
      card.setAttribute('tabindex', '0');
      card.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        if (destination) {
          window.location.assign(destination);
        } else {
          card.click();
        }
      });
    } else {
      card.setAttribute('aria-current', 'page');
    }

    card.dataset.batchBKeyboardReady = 'true';
  }

  function ensureProductStatus(productView) {
    var status = productView.querySelector('[data-batch-b-product-status]');
    if (status) return status;

    status = document.createElement('div');
    status.className = 'visually-hidden';
    status.id = 'batch-b-product-status-' + (++statusCounter);
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('aria-atomic', 'true');
    status.setAttribute('data-batch-b-product-status', '');
    productView.appendChild(status);
    return status;
  }

  function productSelectionSummary(productView) {
    var selected = [];
    productView.querySelectorAll('.productView-options .product-form__radio:checked').forEach(function (input) {
      selected.push(input.getAttribute('aria-label') || input.value);
    });
    productView.querySelectorAll('.productView-options select').forEach(function (select) {
      var option = select.options[select.selectedIndex];
      if (option) selected.push(cleanText(option.textContent));
    });

    var price = productView.querySelector('.productView-price');
    var button = productView.querySelector('[data-btn-addToCart]:not([hidden]), #product-add-to-cart:not([hidden]), .product-form__submit:not([hidden])');
    var parts = selected.concat([
      price && cleanText(price.textContent),
      button && cleanText(button.textContent)
    ]).filter(Boolean);

    return parts.join('. ');
  }

  function announceProductSelection(target) {
    var productView = target.closest('.productView');
    if (!productView) return;
    var status = ensureProductStatus(productView);

    window.setTimeout(function () {
      var summary = productSelectionSummary(productView);
      if (!summary || status.dataset.lastAnnouncement === summary) return;
      status.dataset.lastAnnouncement = summary;
      status.textContent = summary;
    }, 180);
  }

  function enhance(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.productView-options .product-form__radio, .product-edit-options .product-form__radio').forEach(enhanceVariantRadio);
    scope.querySelectorAll('.product-edit-options fieldset').forEach(syncEditRadioGroup);
    scope.querySelectorAll('[data-open-edit-cart]').forEach(function (trigger) {
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-controls', 'halo-edit-cart-popup');
    });
    enhanceEditDialog(scope.matches && scope.matches('[data-edit-cart-popup]') ? scope : scope.querySelector('[data-edit-cart-popup]'));
    enhancePurchaseLimitDialog(purchaseLimitDialog());
    scope.querySelectorAll('.color-option').forEach(enhanceVersionCard);
  }

  function init() {
    enhance(document);

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-open-edit-cart]');
      if (trigger) lastEditTrigger = trigger;

      var purchaseTrigger = event.target.closest('[name="checkout"], [data-checkout], .checkout-button, button[type="submit"], [data-btn-addtocart], [data-btn-addToCart]');
      if (purchaseTrigger && !purchaseLimitDialogIsOpen(purchaseLimitDialog())) {
        lastPurchaseLimitTrigger = purchaseTrigger;
      }
    }, true);

    document.addEventListener('keydown', function (event) {
      var purchaseDialog = purchaseLimitDialog();
      if (purchaseLimitDialogIsOpen(purchaseDialog)) {
        if (event.key === 'Escape') {
          event.preventDefault();
          var purchaseClose = purchaseDialog.querySelector('.close-custom');
          if (purchaseClose) purchaseClose.click();
          return;
        }

        if (event.key === 'Tab') {
          var purchaseFocusables = dialogFocusables(purchaseDialog);
          if (!purchaseFocusables.length) {
            event.preventDefault();
            purchaseDialog.focus({ preventScroll: true });
            return;
          }

          var purchaseFirst = purchaseFocusables[0];
          var purchaseLast = purchaseFocusables[purchaseFocusables.length - 1];
          if (!purchaseDialog.contains(document.activeElement)) {
            event.preventDefault();
            purchaseFirst.focus({ preventScroll: true });
          } else if (event.shiftKey && document.activeElement === purchaseFirst) {
            event.preventDefault();
            purchaseLast.focus({ preventScroll: true });
          } else if (!event.shiftKey && document.activeElement === purchaseLast) {
            event.preventDefault();
            purchaseFirst.focus({ preventScroll: true });
          }
          return;
        }
      }

      if (!document.body.classList.contains('edit-cart-show')) return;
      var dialog = document.querySelector('[data-edit-cart-popup]');
      if (!dialog) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        var closeButton = dialog.querySelector('[data-close-edit-cart]');
        if (closeButton) closeButton.click();
        return;
      }

      if (event.key !== 'Tab') return;
      var focusables = dialogFocusables(dialog);
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];

      if (!dialog.contains(document.activeElement)) {
        event.preventDefault();
        first.focus({ preventScroll: true });
      } else if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus({ preventScroll: true });
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus({ preventScroll: true });
      }
    }, true);

    document.addEventListener('change', function (event) {
      if (event.target.matches('.product-edit-options .product-form__radio')) {
        var fieldset = event.target.closest('fieldset');
        if (fieldset) syncEditRadioGroup(fieldset);
      }
      if (!event.target.matches('.productView-options .product-form__radio, .productView-options select')) return;
      announceProductSelection(event.target);
    }, true);

    if (window.MutationObserver) {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) enhance(node);
          });
        });
        syncEditDialogState();
        syncPurchaseLimitDialogState();
      }).observe(document.body, { childList: true, subtree: true });

      new MutationObserver(syncEditDialogState).observe(document.body, { attributes: true, attributeFilter: ['class'] });
      new MutationObserver(syncPurchaseLimitDialogState).observe(document.body, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ['style', 'class', 'hidden']
      });
    }

    syncEditDialogState();
    syncPurchaseLimitDialogState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
